export const REQUEST_RECOVERY = "request_recovery",
             CONFIRM_RECOVERY = "confirm_recovery",
             RECOVERY         = "recovery";
